export * from './AlternativeCard';
export * from './CreditCardBlock';
export * from './OptionButton';
export * from './OrderSummary';
export * from './CancelSurvey';

export const isProToPro = (oldSub, checkout) => {
  return oldSub?.product === 'benzinga-pro' && checkout?.package?.slug?.includes('pro');
};
